
import { defineComponent } from 'vue';
import { provideCalculationState } from '@/lib/calculationstate';

import { Wizard } from './components/wizard';
import * as Steps from './components/steps';

export default defineComponent({
  name: 'nvschade-vue-calculator',
  components: {
    Wizard,
    ...Steps,
  },
  setup() {
    const state = provideCalculationState();

    return {
      state,
    };
  },
});
